// extracted by mini-css-extract-plugin
module.exports = {"close":"AlertBanner-module__close___ChWG_"};